import React from 'react';

import { PATH } from 'src/pages/quotation';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { t } from 'src/libs/i18n';
import { SCREENS } from 'src/constants/screens';

const DashboardRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/quotation')),
        title: t('menu_home.quotation_order_history'),
        screenId: SCREENS.R1502,
      },
    ],
  },
];

export default DashboardRoute;
